import { render } from "./KaaSChart.vue?vue&type=template&id=1ff674a9&scoped=true"
import script from "./KaaSChart.vue?vue&type=script&lang=js"
export * from "./KaaSChart.vue?vue&type=script&lang=js"

import "./KaaSChart.vue?vue&type=style&index=0&id=1ff674a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff674a9"]])

export default __exports__